import '@api-mock'
import '@/assets/scss/global.scss'
import 'date-format-lite'

import { createApp } from 'vue'
import * as Vue3 from 'vue'
import * as Pinia from 'pinia'

import App from '@/App.vue'
import i18n from '@/i18n'
import { pinia } from '@/pinia.js'
import router from '@/router'
import httpApi from '@/utils/http-api.js'
import { initGTM } from '@/utils/tracker.js'

window.Vue3 = Vue3
// @blibli/affiliate.module-share-uap's UMD bundle (both the current and
// the -old alias) is built against Vue3/pinia as bare globals, matching
// window.Vue3 above.
window.pinia = Pinia

const app = createApp(App)
app.use(router)
app.use(i18n)

app.use(pinia)
httpApi.setupHttpApi(pinia)

initGTM(app, router)

app.mount('#uap-ui')
